import { render, staticRenderFns } from "./HomeMaterials.vue?vue&type=template&id=67130e46&scoped=true&"
import script from "./HomeMaterials.vue?vue&type=script&lang=js&"
export * from "./HomeMaterials.vue?vue&type=script&lang=js&"
import style0 from "./HomeMaterials.vue?vue&type=style&index=0&id=67130e46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67130e46",
  null
  
)

export default component.exports